<template>
  <div>
    <accounting-filter
      :value="filters"
      :vendors="vendors"
      :clients="clientListSelect"
      :periods="periodListSelect"
      @input="applyFilters"
      @clear="clear"
    />
    <register-pay
      :vendorProp="vendorProp"
      :paymentInfo="totalAmountExpenses"
      @sendPay="sendPayToBack"
    />
    <expense-detail :expense_id="expense_id" @refresh-table="allRefresh"/>
    <!-- <button @click="taxReturn">Open Tax Return</button> -->
    <vs-row>
      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <vs-row vs-justify="center">
          <vs-col type="flex" vs-justify="center" vs-align="center">
            <vs-card :class="activePending">
              <div>
                <div slot="header">
                  <h4 @click="clickTitle('pending')" class="donutTitle">
                    {{ $t('pending_expenses_by_client') }}
                  </h4>
                </div>
                <div class="vs-con-loading__container pending-donut-loading">
                  <donut-chart
                    :series="pendingDonutSeries"
                    :chartId="'pendingDonut'"
                    :center_label="$t('pending_plural')"
                    @clickDonutSection="tableRefresh"
                  />
                </div>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <vs-row vs-justify="center">
          <vs-col type="flex" vs-justify="center" vs-align="center">
            <vs-card :class="activeRejected">
              <div>
                <div slot="header">
                  <h4 @click="clickTitle('rejected')" class="donutTitle">
                    {{ $t('rejected_expenses_by_client') }}
                  </h4>
                </div>
                <div class="vs-con-loading__container rejected-donut-loading">
                  <donut-chart
                    :series="rejectedDonutSeries"
                    :chartId="'rejectedDonut'"
                    :center_label="$t('rejected_plural')"
                    @clickDonutSection="tableRefresh"
                  />
                </div>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-col>
      <vs-col vs-lg="4" vs-sm="12" class="p-2">
        <vs-row vs-justify="center">
          <vs-col type="flex" vs-justify="center" vs-align="center">
            <vs-card :class="activeInvoiced">
              <div>
                <div slot="header">
                  <h4 @click="clickTitle('invoiced')" class="donutTitle">
                    {{ $t('invoiced_expenses_by_client') }}
                  </h4>
                </div>
                <div class="vs-con-loading__container invoice-donut-loading">
                  <donut-chart
                    :series="InvoicedDonutSeries"
                    :chartId="'invoicedDonut'"
                    :center_label="$t('invoiced_plural')"
                    @clickDonutSection="tableRefresh"
                  />
                </div>
              </div>
            </vs-card>
          </vs-col>
        </vs-row>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col vs-lg="12" vs-sm="12" class="p-2">
        <vx-card style="min-height: 85vh" class="px-1">
          <vs-row id="expense-list-loading">
            <div class="vx-col w-full">
              <vs-table :data="expensesTableList">
                <template slot="header">
                  <vx-tooltip
                    :text="$t('add_payment')"
                    v-show="selected.length > 0"
                  >
                    <vs-button
                      color="#0051D6"
                      type="filled"
                      icon-pack="feather"
                      icon="icon-dollar-sign"
                      class="mx-2"
                      @click="registerPay"
                    >
                      {{ $t('add_payment') }}
                    </vs-button>
                  </vx-tooltip>
                  <div class="con-input-search vs-table--search">
                    <input
                      class="input-search vs-table--search-input"
                      type="text"
                      v-model="params.search"
                      @keyup.enter="tableRefresh()"
                    />
                    <vs-icon icon="search"></vs-icon>
                  </div>
                  <vs-button
                    color="primary"
                    type="filled"
                    icon-pack="feather"
                    icon="icon-filter"
                    class="mx-2"
                    radius
                    @click="openFilter"
                  ></vs-button>
                  <!-- @click="openFilter" -->
                </template>
                <template slot="thead">
                  <vs-th class="qb-sticky" v-show="selectable"> </vs-th>
                  <th-sort :text="$t('client')" column="Cl.ClientName" @sort="handleClickSort"/>
                  <th-sort :text="$t('vendor')" column="v.VendorName" @sort="handleClickSort"/>
                  <th-sort :text="`${$t('folio')}|${$t('date')}|${$t('year')}-${$t('week')}|${$t('pay_date')}`" column="p.Year,p.Week" @sort="handleClickSort"/>                
                  <th-sort :text="$t('category')" column="cat.CategoryName" @sort="handleClickSort"/>
                  <th-sort :text="$t('total')" column="Expenses.Total" @sort="handleClickSort"/>
                  <vs-th class="qb-sticky">
                    {{ $t('actions') }}
                  </vs-th>
                </template>

                <template slot-scope="{ data }" >
                  <vs-tr
                    :data="tr"
                    :key="indextr"
                    v-for="(tr, indextr) in data"
                  >
                    <vs-td :style="{ width: '2vw' }" v-if="selectable">
                      <vs-checkbox
                        :disabled="
                          checkConditions(
                            data[indextr].ClientId,
                            data[indextr].VendorName,
                            data[indextr].CurrencyId
                          )
                        "
                        :vs-value="data[indextr]"
                        v-model="selected"
                      ></vs-checkbox>
                    </vs-td>
                    <vs-td :style="{ width: '20vw' }" class="text-left">
                      {{ data[indextr].ClientName }}
                    </vs-td>

                    <vs-td :style="{ width: '20vw' }" class="text-left">
                      {{ data[indextr].VendorName }}
                    </vs-td>

                    <vs-td :style="{ width: '20vw' }" class="text-left" v-if="data[indextr].status != 1">
                      {{ data[indextr].Folio }} <b>|</b>
                      {{ formatDate(data[indextr].ExpenseDate) }} <b>|</b>
                      {{ data[indextr].Year }}-{{ data[indextr].Week }} <b>|</b>
                      {{ formatDate(data[indextr].PayDate) }}
                    </vs-td>

                    <vs-td :style="{ width: '20vw' }" class="text-left" v-else>
                      {{ data[indextr].Folio }} <b>|</b>
                      {{ formatDate(data[indextr].ExpenseDate) }} <b>|</b>
                      {{ data[indextr].Year }}-{{ data[indextr].Week }} <b>|</b>
                      {{ formatDate(data[indextr].PayDate) }}
                    </vs-td>

                    <vs-td :style="{ width: '20vw' }" class="text-left">
                      <span
                        class="material-icons sm"
                        :style="{
                          fontSize: '8px',
                          color: data[indextr].category_color,
                        }"
                      >
                        lens
                      </span>
                      {{ data[indextr].CategoryName }}
                    </vs-td>
                    <vs-td :style="{ width: '15vw' }" class="text-right">
                      {{
                        `$ ${formatNumber(data[indextr].totalxml, 2)} ${
                          data[indextr].CurrencyId
                        }`
                      }}
                    </vs-td>
                    <vs-td :data="data[indextr].id" :style="{ width: '5vw' }">
                      <feather-icon
                        @click="expenseDetail(data[indextr].ExpenseId)"
                        icon="ArrowRightCircleIcon"
                        svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer"
                      />
                    </vs-td>
                  </vs-tr>
                  <vs-tr>
                    <vs-td colspan="100%">
                      <div
                        v-if="data.length"
                        v-observe-visibility="infiniteHandler"
                      ></div>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </vs-row>
        </vx-card>
      </vs-col>
    </vs-row>
  </div>
</template>

<script>
import AccountingFilter from '@/views/apps/accounting/components/AccountingFilter.vue'
import DonutChart from '@/views/apps/accounting/components/DonutChart.vue'
import ExpenseDetail from '@/views/apps/accounting/components/ExpenseDetail.vue'
import RegisterPay from '@/views/apps/accounting/components/RegisterPay.vue'
import ThSort from '@/views/components/ThSort.vue'

import moduleExpense from '@/store/expense/moduleExpense.js'

import expense from '@/http/requests/expense'
import accounting from '@/http/requests/accounting'
import client from '@/http/requests/client'
import invoice from '@/http/requests/invoice'
import validate from '@/mixins/Validate.js'

export default {
  mixins: [validate],
  components: {
    AccountingFilter,
    DonutChart,
    ExpenseDetail,
    RegisterPay,
    ThSort
  },
  data() {
    return {
      TACNAClients:['17','18','19','39','62'],
      expense_id: {},
      items: {},
      vendorInfo: {},
      selected: [],
      selectable: false,
      periodListSelect: [],
      clientListSelect: [],
      lastPage: 1,
      params: {
        page: 1,
        search: '',
        sortBy: ['Expenses.ReceivedDate'],
        sort: ['DESC'],
        StatusDonutId: 'rejectedDonut',
        ClientName: null,
        StatusId: [2]
      },
      filters: {
        invoiced: false,
        pending: true,
        rejected: false,
        vendor: [],
        client: [],
        date: '',
        period: [],
        ExpenseDate: null,
        currencies:[]
      },
      pendingDonutSeries: [0],
      rejectedDonutSeries: [0],
      InvoicedDonutSeries: [0],
    }
  },
  computed: {
    filter() {
      return this.$store.state.filter
    },
    currentLocale() {
      return this.$i18n.locale
    },
    expensesTableList() {
      return this.$store.state.expense.expenseList
    },
    vendors() {
      return this.$store.state.expense.vendors
    },
    activePending() {
      return this.filters.pending ? 'active' : 'inactive'
    },
    activeRejected() {
      return this.filters.rejected ? 'active' : 'inactive'
    },
    activeInvoiced() {
      return this.filters.invoiced ? 'active' : 'inactive'
    },
    totalAmountExpenses() {
      let currency = ''
      if (this.selected.length > 0) {
        currency = this.selected[0].CurrencyId
      }
      return { currency: currency }
    },
    vendorProp() {
      if (this.selected.length > 0) {
        return {
          id: this.selected[0].VendorId,
          name: this.selected[0].VendorName
        }
      }
      return {}
    }
  },
  watch: {
    filter(val) {
      if (val.expense_id !== undefined) {
        this.expenseDetail(val.expense_id)
      }
    },
    currentLocale() {
      //Translate for center label Donuts
      ApexCharts.exec(
        'pendingDonut',
        'updateOptions',
        {
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  total: {
                    label: this.$i18n.messages[this.$i18n.locale].pending_plural
                  }
                }
              }
            }
          }
        },
        false,
        true
      )
      ApexCharts.exec(
        'rejectedDonut',
        'updateOptions',
        {
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  total: {
                    label: this.$i18n.messages[this.$i18n.locale].rejected_plural
                  }
                }
              }
            }
          }
        },
        false,
        true
      )
      ApexCharts.exec(
        'invoicedDonut',
        'updateOptions',
        {
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  total: {
                    label: this.$i18n.messages[this.$i18n.locale]
                      .invoiced_plural
                  }
                }
              }
            }
          }
        },
        false,
        true
      )
    }
  },
  created() {
    if (!moduleExpense.isRegistered) {
      this.$store.registerModule('expense', moduleExpense)
      moduleExpense.isRegistered = true
    }
  },
  mounted() {
    this.$store.dispatch('expense/clearExpenseList')
      if (this.filter.hasOwnProperty('expense_id')) {
        this.expenseDetail(this.filter.expense_id)
      }
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch('expense/fetchVendorList')
      invoice.getPeriodList().then(res => {
        this.periodListSelect = res.data.periodList
      })
      client.list().then(response => {
        this.clientListSelect = [...response.data.clients]
      })
      this.tableRefresh()
      this.fillAllDonuts()
    },
    checkConditions(ClientId,VendorName, CurrencyId) {
      let Condition1=false
      let condition2=false
      if (this.selected.length > 0) {
        (
          this.selected[0].VendorName != VendorName
        ||this.selected[0].CurrencyId != CurrencyId
        ) ? Condition1=true:Condition1=false
        
        if(this.TACNAClients.indexOf(this.selected[0].ClientId) != -1){
            this.TACNAClients.indexOf(ClientId) != -1 ? condition2=false:condition2=true 
          }else if(this.selected[0].ClientId != ClientId){
            condition2=true
          }
      }
      return Condition1||condition2
    },
    fillDonutTotales(donutId, totalsToChart) {
      let seriesArray = []
      let labelsArray = []
      let colorsArray = []
      if (totalsToChart.length == 0) {
        seriesArray = [0]
        labelsArray = ['NO LABEL']
        colorsArray = ['#FFFFFF']
      } else {
        totalsToChart.forEach(element => {
          seriesArray[seriesArray.length] = parseInt(element.total, 10)
          labelsArray[labelsArray.length] = element.ShortName
          colorsArray[colorsArray.length] = element.color
        })
      }
      switch (donutId) {
        case 'pendingDonut':
          this.pendingDonutSeries = seriesArray
          break
        case 'rejectedDonut':
          this.rejectedDonutSeries = seriesArray
          break
        default:
          this.InvoicedDonutSeries = seriesArray
          break
      }
      ApexCharts.exec(
        donutId,
        'updateOptions',
        {
          fill: {
            colors: colorsArray
          },
          legend: {
            markers: {
              fillColors: colorsArray
            }
          },
          labels: labelsArray,
          tooltip:{
            fillSeriesColor:false
          }
        },
        false,
        true
      )
    },
    tableRefresh(config) {
      this.topTableScroll()
      if (config != undefined) {
        this.selectable = false
        this.selected = []
        this.filters.invoiced = false
        this.filters.pending = false
        this.filters.rejected = false
        this.params.ClientName = config.w.config.labels[config.dataPointIndex]
        switch (config.w.config.chart.id) {
          case 'invoicedDonut':
            this.selectable = true
            this.filters.invoiced = true
            this.params.StatusId = [6]
            break
          case 'rejectedDonut':
            this.params.StatusId = [0]
            this.filters.rejected = true
            break
          default:
            this.filters.pending = true
            this.params.StatusId = [2]
            break
        }
      }
      this.params.page = 1
      this.getExpensesTableList()
        .then(res => this.closeTableLoading())
        .catch(err => this.closeTableLoading())
    },
    getExpensesTableList() {
      this.openTableLoading()
      return this.$store.dispatch(
        'expense/fetchExpenseListDashboard',
        this.params
      ).then(res => {
        this.lastPage = res.data.last_page
      })
    },
    handleClickSort(e){
      this.params.sort=e.sort
      this.params.sortBy=e.sortBy
      this.tableRefresh()
    },
    infiniteHandler(isVisible) {
      if (!isVisible) { return }
      if (this.params.page >= this.lastPage) { return }
      this.params.page++
      this.getExpensesTableList()
        .then(res => this.closeTableLoading())
        .catch(err => this.closeTableLoading())
    },
    openTableLoading: function () {
      this.$vs.loading({
        container: '#expense-list-loading',
        scale: 0.6
      })
    },
    closeTableLoading: function () {
      this.$vs.loading.close('#expense-list-loading > .con-vs-loading')
    },
    openLoadingDonut(id) {
      this.$vs.loading({
        container: `.${id}`,
        scale: 0.6
      })
    },
    closeLoadingDonut: function (id) {
      this.$vs.loading.close(`.${id} > .con-vs-loading`)
    },
    closeRegisterPayment() {
      this.$store.dispatch('toggleSidebar', '')
    },
    expenseDetail(expense_id) {
      this.$store.dispatch('setFilter',{});
      this.expense_id = expense_id
      this.$store.dispatch('toggleSidebar', 'expense-detail')
    },
    fillAllDonuts() {
      this.openLoadingAllDonuts()
      accounting
        .getDonutsInfo(this.params)
        .then(res => {
          this.fillDonutTotales('pendingDonut', res.data.pendingCount)
          this.fillDonutTotales('rejectedDonut', res.data.rejectedCount)
          this.fillDonutTotales('invoicedDonut', res.data.invoicedCount)
          this.closeLoadingAllDonuts()
        })
        .catch(err => {
          this.closeLoadingAllDonuts()
        })
    },
    openLoadingAllDonuts() {
      this.openLoadingDonut('pending-donut-loading')
      this.openLoadingDonut('rejected-donut-loading')
      this.openLoadingDonut('invoice-donut-loading')
    },
    closeLoadingAllDonuts() {
      this.closeLoadingDonut('pending-donut-loading')
      this.closeLoadingDonut('rejected-donut-loading')
      this.closeLoadingDonut('invoice-donut-loading')
    },
    openFilter() {
      this.$store.dispatch('toggleSidebar', 'accounting-filter')
    },
    applyFilters(filters) {
      this.selected = []
      this.selectable = false
      this.filters = filters
      this.params.VendorId = filters.vendor
      if (filters.vendor != null) {
        if (filters.vendor.length == 0) {
          this.params.VendorId = null
        }
      }
      this.params.ClientId = filters.client
      if (filters.client != null) {
        if (filters.client.length == 0) {
          this.params.ClientId = null
        }
      }
      this.params.PeriodId = filters.period
      if (filters.period != null) {
        if (filters.period.length == 0) {
          this.params.PeriodId = null
        }
      }
      this.params.currencies = filters.currencies
      if (filters.currencies != null) {
        if (filters.currencies.length == 0) {
          this.params.currencies = null
        }
      }

      this.params.StatusId = []
      if (filters.pending) {
        this.params.StatusId.push('2')
      }
      if (filters.invoiced) {
        this.params.StatusId.push('6')
        this.selectable = true
      }
      if (filters.rejected) {
        this.params.StatusId.push('0')
      }
      this.params.ClientName = null
      this.params.ExpenseDate = this.filters.date
      this.allRefresh()
    },
    taxReturn() {
      this.$store.dispatch('toggleSidebar', 'tax-return')
    },
    registerPay() {
      this.$store.dispatch('toggleSidebar', 'register-pay')
    },
    sendPayToBack(payment) {
      // let expensesIds = []
      // this.selected.forEach((element, index) => {
      //   expensesIds[index] = element.ExpenseId
      // })
      // let paramsPayment = {
      //   expensesIds: expensesIds,
      //   payment: payment
      // }
      let data = new FormData();
      
      //payment.files.forEach(function (file, i) {
      if(payment.files.length > 0){
        data.append('file', payment.files[0])
      }
      //})
      this.selected.forEach((element, index) => {
        data.append('expensesIds[]',  element.ExpenseId)
      })
      data.append('amount', payment.amount)
      data.append('currency', payment.currency)
      data.append('policy', payment.policy)
      data.append('method_label', payment.method.label)
      data.append('method_value', payment.method.value)
      
      expense
        .payExpenses(data)
        .then(res => {
          if (res.data.message != undefined) {
            this.$vs.notify({
              color: 'danger',
              title: 'Attention',
              text: `${res.data.message}`
            })
          } else {
            this.$vs.notify({
              color: 'success',
              title: 'Success',
              text: 'Payment Received'
            })
            this.selected = []
            this.allRefresh()
            this.closeRegisterPayment()
          }
        })
        .catch(err => {
          this.displayErrors(err);
        })
    },
    clickTitle(status) {
      this.selected = []
      this.selectable = false
      this.filters.invoiced = false
      this.filters.pending = false
      this.filters.rejected = false
      this.filters[status] = true
      switch (status) {
        case 'invoiced':
          this.selectable = true
          this.params.StatusId = [6]
          break
        case 'rejected':
          this.params.StatusId = [0]
          break
        default:
          this.params.StatusId = [2]
          break
      }
      this.params.ClientName = null
      this.tableRefresh()
    },
    clear() {
      this.params = {
        page: 1,
        search: '',
        sortBy: ['Expense.RecievedDate'],
        sort: ['desc'],
        StatusDonutId: 'rejectedDonut',
        ClientName: null,
        StatusId: [2]
      }
      this.init()
    },
    topTableScroll() {
      let elemento = document.getElementsByClassName(
        'vs-con-tbody vs-table--tbody'
      )
      elemento[1].scroll({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },
    allRefresh(){
      this.fillAllDonuts()
      this.tableRefresh()
    }
  }
}
</script>

<style>
.vs-con-table .vs-con-tbody {
  /* height: 80vh;
  width: calc(100vw - 160px); */
  overflow: auto;
}
.fixedHead table {
  /*width: 2500px; */
  table-layout: fixed;
}
.fixedHead table th {
  min-width: 100px;
  cursor: pointer;
}

.fixedHead table thead th:not([scope='row']) {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 2000;
  background-color: #ffffff;
}

.donutTitle {
  cursor: pointer;
  padding: 10px;
}

h4.donutTitle:hover {color:#bc1300}

.inactive {
  border-bottom: 3px solid #ffffff;
}
.active {
  border-bottom: 3px solid #bc1300;
}

</style>
